import { render, staticRenderFns } from "./ModalCreditComponent.vue?vue&type=template&id=161953bc"
import script from "./ModalCreditComponent.vue?vue&type=script&lang=js"
export * from "./ModalCreditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports